import clsx from "clsx";
import { ScanCameraIconWrapper, UserAddressTextFieldRoot } from "./UserAddressTextField.styles";
import { UserAddressTextFieldProps } from "./UserAddressTextField.types";
import useUserAddressTextField from "./hooks/useUserAddressTextField";
import { CameraIcon } from "ui/common/icons";
import SearchBar from "ui/common/components/input/SearchBar/SearchBar";

function UserAddressTextField({
    className,
    variant = "outlined",
    error: errorProp,
    defaultValue = "",
    ...rest
}: UserAddressTextFieldProps) {
    const {
        scanned,
        searchBarProps: { error, ...restOfSearchBarProps },
        handleCameraClick,
    } = useUserAddressTextField(defaultValue);

    return (
        <UserAddressTextFieldRoot>
            <SearchBar
                key={scanned}
                className={clsx("user-address-text-field", className)}
                error={errorProp || error}
                variant={variant}
                {...restOfSearchBarProps}
                {...rest}
            />
            <ScanCameraIconWrapper onClick={handleCameraClick}>
                <CameraIcon />
            </ScanCameraIconWrapper>
        </UserAddressTextFieldRoot>
    );
}

export default UserAddressTextField;
